/*
 *减免本金 减免息费
 *
 * *
 * */
import { ticketClient } from "@/api/ticketClient";
import { DoReducePrincipalReq,DoReduceOtherReq,ApplyReducePenaltyFieldDetail  } from "@/pbjs/xcommon/ticket_pb";
import { Page } from "@/utils/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import InnerRequest from "./request";


export interface Options {
    TicketId ?:number;
    ItemId ?:number;
    ReductionAmount ?:number;
    Reason ?:string;
    penaltyFormFillinList ?:any; // 减免息费需要的参数
    orderid?:string//orderid
}


export function getReducePrincipalReq(arg: Options) {
    let request: any = new DoReducePrincipalReq();
    request.setTicketid(arg.TicketId);
    request.setItemid(arg.ItemId);
    request.setReductionamount(arg.ReductionAmount);
    request.setReason(arg.Reason);
    request.setOrderid(arg.orderid)
    return request ;
}

export const getReducePrincipalRequest = new InnerRequest(
    ticketClient,
    ticketClient.doReducePrincipal
);

export function getReduceOtherReq(arg: Options) {
    let request: any = new DoReduceOtherReq();
    request.setTicketid(arg.TicketId);
    request.setItemid(arg.ItemId);
    request.setReason(arg.Reason);
    request.setOrderid(arg.orderid)

    let _arr: any[] = [];
    arg.penaltyFormFillinList.forEach((item: any) => {
        let requestAuto: any = new ApplyReducePenaltyFieldDetail();
        requestAuto.setFieldname(item.fieldname);
        requestAuto.setValue(Number(item.fieldvalue));
        requestAuto.setDisplayname(item.displayname);
        _arr.push(requestAuto);
    });
    request.setReductionfieldsList(_arr)
    return request ;
}

export const getReduceOtherRequest = new InnerRequest(
    ticketClient,
    ticketClient.doReduceOther 
);
 